import React, { useState, useEffect } from "react";
import { Card } from "../../../components/Cards/Card";
import { Row, Col } from "react-bootstrap";
import DocumentUploadCard from "../../../components/CustomControls/DocumentUpload/DocumentUploadCard";
import { attachmentEntityType } from "../../../variables/Enums";
import {
  getHospitalFiles,
  uploadAttachmentMetadata,
} from "../../../api/clinicalTrial";
import { Spinner } from "../../../components/Utils/Loaders";
import { ModalCreateCategory } from "../ISFFiles/ModalCreateCategory";
import { HandleApiError } from "../../../components/Notifications/APIErrorHandler";
import { useTranslation } from "react-i18next";
import { Add } from "../../../components/Icons/Icons";
import { useAuthorization } from "../../../components/Authorization/useAuthorization";

export const HospitalFiles = () => {
  const { t } = useTranslation();
  const [, , isAuthorized] = useAuthorization();
  const [items, setItems] = useState();
  const [showNewCategoryForm, setShowNewCategoryForm] = useState(false);

  const loadData = async () => {
    const result = await getHospitalFiles();

    if (result.status === 200) {
      setItems(result.data.attachments);
    }
  };

  useEffect(() => {
    if (!!items) {
      return;
    }

    loadData();
  }, []);

  const handleAttachmentChange = async (attachment) => {
    if (attachment?.id && attachment?.extendedMetadata) {
      try {
        await uploadAttachmentMetadata(
          attachmentEntityType.Hospital,
          attachment.id,
          attachment.extendedMetadata
        );
      } catch (err) {
        HandleApiError(err);
      }
    }

    setItems((prev) =>
      prev.map((currentAttachment) =>
        currentAttachment.attachmentCategoryId ===
        attachment.attachmentCategoryId
          ? { ...currentAttachment, ...attachment }
          : currentAttachment
      )
    );
  };

  const groupArrayByTwo = (arr) => {
    const result = [];
    for (let i = 0; i < arr.length; i += 2) {
      result.push(arr.slice(i, i + 2));
    }
    return result;
  };

  const handleCategoryCreated = (created) => {
    const toAttachmentItem = (created) => ({
      attachmentFileName: null,
      attachmentCategoryId: created.id,
      attachmentCategoryName: created.name,
      entityTypeId: created.attachmentEntityTypeId,
      multipleAttachments: !!created.multipleFiles,
      id: null,
      extendedMetadata: null,
      systemId: created.systemId,
    });

    const newItem = toAttachmentItem(created);
    const newItems = [...items, newItem];

    setItems(newItems);

    setShowNewCategoryForm(false);
  };

  return (
    <Card
      header={
        <Row>
          <Col md={6}>
            <label className="form-check-label mb-0">
              {t("clinicalTrials.hospitalFiles.sectionTile")}
            </label>
          </Col>
        </Row>
      }
      content={
        <>
          {!items && <Spinner />}
          {items &&
            groupArrayByTwo(items).map((group, index) => (
              <Row key={index}>
                {group.map((item, index) => (
                  <Col md={6} key={index}>
                    <DocumentUploadCard
                      attachmentEntityTypeId={attachmentEntityType.Hospital}
                      entityId={null}
                      attachment={item}
                      legend={t("clinicalTrials.hospitalFiles.sectionTile")}
                      showDownloadButton={false}
                      onAttachmentChange={handleAttachmentChange}
                      disabled={!isAuthorized(["Startups.Edit"])}
                    />
                  </Col>
                ))}
              </Row>
            ))}
          <div style={{ marginTop: "10px" }}>
            <hr />
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => setShowNewCategoryForm(true)}
              disabled={!isAuthorized(["Startups.Edit"])}
            >
              <Add />
              {t("clinicalTrials.isfFiles.createCategory")}
            </button>
          </div>
          <ModalCreateCategory
            show={showNewCategoryForm}
            onClose={() => setShowNewCategoryForm(false)}
            onCreated={handleCategoryCreated}
            defaultEntityTypeId={attachmentEntityType.Hospital}
          />
        </>
      }
    />
  );
};

export default HospitalFiles;
